/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "düýn",
        "0": "şu gün",
        "1": "ertir",
        "future": {
          "one": "{0} günden",
          "other": "{0} günden"
        },
        "past": {
          "one": "{0} gün öň",
          "other": "{0} gün öň"
        }
      },
      "day-narrow": {
        "-1": "düýn",
        "0": "şu gün",
        "1": "ertir",
        "future": {
          "one": "{0} g-den",
          "other": "{0} g-den"
        },
        "past": {
          "one": "{0} g. öň",
          "other": "{0} g. öň"
        }
      },
      "day-short": {
        "-1": "düýn",
        "0": "şu gün",
        "1": "ertir",
        "future": {
          "one": "{0} g-den",
          "other": "{0} g-den"
        },
        "past": {
          "one": "{0} g. öň",
          "other": "{0} g. öň"
        }
      },
      "hour": {
        "0": "şu sagat",
        "future": {
          "one": "{0} sagatdan",
          "other": "{0} sagatdan"
        },
        "past": {
          "one": "{0} sagat öň",
          "other": "{0} sagat öň"
        }
      },
      "hour-narrow": {
        "0": "şu sagat",
        "future": {
          "one": "{0} sag-dan",
          "other": "{0} sag-dan"
        },
        "past": {
          "one": "{0} sag. öň",
          "other": "{0} sag. öň"
        }
      },
      "hour-short": {
        "0": "şu sagat",
        "future": {
          "one": "{0} sag-dan",
          "other": "{0} sag-dan"
        },
        "past": {
          "one": "{0} sag. öň",
          "other": "{0} sag. öň"
        }
      },
      "minute": {
        "0": "şu minut",
        "future": {
          "one": "{0} minutdan",
          "other": "{0} minutdan"
        },
        "past": {
          "one": "{0} minut öň",
          "other": "{0} minut öň"
        }
      },
      "minute-narrow": {
        "0": "şu minut",
        "future": {
          "one": "{0} min-dan",
          "other": "{0} min-dan"
        },
        "past": {
          "one": "{0} min. öň",
          "other": "{0} min. öň"
        }
      },
      "minute-short": {
        "0": "şu minut",
        "future": {
          "one": "{0} min-dan",
          "other": "{0} min-dan"
        },
        "past": {
          "one": "{0} min. öň",
          "other": "{0} min. öň"
        }
      },
      "month": {
        "-1": "geçen aý",
        "0": "şu aý",
        "1": "indiki aý",
        "future": {
          "one": "{0} aýdan",
          "other": "{0} aýdan"
        },
        "past": {
          "one": "{0} aý öň",
          "other": "{0} aý öň"
        }
      },
      "month-narrow": {
        "-1": "geçen aý",
        "0": "şu aý",
        "1": "indiki aý",
        "future": {
          "one": "{0} aýdan",
          "other": "{0} aýdan"
        },
        "past": {
          "one": "{0} aý öň",
          "other": "{0} aý öň"
        }
      },
      "month-short": {
        "-1": "geçen aý",
        "0": "şu aý",
        "1": "indiki aý",
        "future": {
          "one": "{0} aýdan",
          "other": "{0} aýdan"
        },
        "past": {
          "one": "{0} aý öň",
          "other": "{0} aý öň"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "geçen çärýek",
        "0": "şu çärýek",
        "1": "indiki çärýek",
        "future": {
          "one": "{0} çärýekden",
          "other": "{0} çärýekden"
        },
        "past": {
          "one": "{0} çärýek öň",
          "other": "{0} çärýek öň"
        }
      },
      "quarter-narrow": {
        "-1": "geçen çärýek",
        "0": "şu çärýek",
        "1": "indiki çärýek",
        "future": {
          "one": "{0} ç-den",
          "other": "{0} ç-den"
        },
        "past": {
          "one": "{0} ç. öň",
          "other": "{0} ç. öň"
        }
      },
      "quarter-short": {
        "-1": "geçen çärýek",
        "0": "şu çärýek",
        "1": "indiki çärýek",
        "future": {
          "one": "{0} çär-den",
          "other": "{0} çär-den"
        },
        "past": {
          "one": "{0} çär. öň",
          "other": "{0} çär. öň"
        }
      },
      "second": {
        "0": "häzir",
        "future": {
          "one": "{0} sekuntdan",
          "other": "{0} sekuntdan"
        },
        "past": {
          "one": "{0} sekunt öň",
          "other": "{0} sekunt öň"
        }
      },
      "second-narrow": {
        "0": "häzir",
        "future": {
          "one": "{0} sek-dan",
          "other": "{0} sek-dan"
        },
        "past": {
          "one": "{0} sek. öň",
          "other": "{0} sek. öň"
        }
      },
      "second-short": {
        "0": "häzir",
        "future": {
          "one": "{0} sek-dan",
          "other": "{0} sek-dan"
        },
        "past": {
          "one": "{0} sek. öň",
          "other": "{0} sek. öň"
        }
      },
      "week": {
        "-1": "geçen hepde",
        "0": "şu hepde",
        "1": "indiki hepde",
        "future": {
          "one": "{0} hepdeden",
          "other": "{0} hepdeden"
        },
        "past": {
          "one": "{0} hepde öň",
          "other": "{0} hepde öň"
        }
      },
      "week-narrow": {
        "-1": "geçen hepde",
        "0": "şu hepde",
        "1": "indiki hepde",
        "future": {
          "one": "{0} h-den",
          "other": "{0} h-den"
        },
        "past": {
          "one": "{0} h. öň",
          "other": "{0} h. öň"
        }
      },
      "week-short": {
        "-1": "geçen hepde",
        "0": "şu hepde",
        "1": "indiki hepde",
        "future": {
          "one": "{0} hep-den",
          "other": "{0} hep-den"
        },
        "past": {
          "one": "{0} hep. öň",
          "other": "{0} hep. öň"
        }
      },
      "year": {
        "-1": "geçen ýyl",
        "0": "şu ýyl",
        "1": "indiki ýyl",
        "future": {
          "one": "{0} ýyldan",
          "other": "{0} ýyldan"
        },
        "past": {
          "one": "{0} ýyl öň",
          "other": "{0} ýyl öň"
        }
      },
      "year-narrow": {
        "-1": "geçen ýyl",
        "0": "şu ýyl",
        "1": "indiki ýyl",
        "future": {
          "one": "{0} ý-dan",
          "other": "{0} ý-dan"
        },
        "past": {
          "one": "{0} ý. öň",
          "other": "{0} ý. öň"
        }
      },
      "year-short": {
        "-1": "geçen ýyl",
        "0": "şu ýyl",
        "1": "indiki ýyl",
        "future": {
          "one": "{0} ý-dan",
          "other": "{0} ý-dan"
        },
        "past": {
          "one": "{0} ý. öň",
          "other": "{0} ý. öň"
        }
      }
    },
    "locale": "tk"
  });
}